import './ListBox.scss';
import Control from "../../Control";
import Delegate from "../../Delegate";
import ListItem, {IItem} from "./ListItem";
import NP, {EventArgs} from "../../NP";
import ListGroupHeader from "./ListGroupHeader";
import ListItemCheckBox from "./ListItemCheckBox";
import ListItemRadio from "./ListItemRadio";
import {escapeHTML} from "../../util-fun";


export default class ListBox extends Control {

	public EvItemSelected: Delegate;
	public EvDeletedClick: Delegate;
	public EvDeletingClick: Delegate;
	public EvItemClick: Delegate;
	public EvItemCreated: Delegate;

	private _Selectable: boolean;
	private _TwoLines: boolean;
	protected _Items: Array<ListItem>;
	private _SelectedItem: ListItem;
	private _DelBtnSettings: object;
	private _AddToolTips: boolean;
	private _MultiSelect: boolean;

	private _deletedClick: boolean;
	private _nonIn: boolean;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvItemSelected = new Delegate();
		this.EvDeletedClick = new Delegate();
		this.EvDeletingClick = new Delegate();
		this.EvItemClick = new Delegate();
		this.EvItemCreated = new Delegate();
		this._Selectable = true;
		this._TwoLines = false;
		this._Items = [];
		this._SelectedItem = null;
		this._DelBtnSettings = null;
		this._AddToolTips = false;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render(`<ul class="app-list"/>`);
		if (this._TwoLines)
			this.addClass('app-list--two-line');

		this.setItems(this._Items, false);
	}

	addItems(items: IItem[])
	{
		if (items)
			items.forEach((item: IItem) => this.addItem(item));
	}

	addItem(value: IItem | ListItem)
	{
		return this.insert(value);
	}

	setEnabled(value: boolean)
	{
		super.setEnabled(value);
		if (this._root)
		{
			if (!value)
			{
				this._nonIn = true;
				this.addClass('app-list--non-interactive');
			}
			else
			{
				if (this._nonIn)
					this.removeClass('app-list--non-interactive');
			}
		}
	}

	setSelectable(value: boolean)
	{
		this._Selectable = !!value;
	}

	_onItemClick(listitem: ListItem, e: EventArgs)
	{
		if (this._Enabled)
		{
			if (this._deletedClick)
			{
				this._deletedClick = false;
			}
			else
			{
				this.setSelectedItem(listitem);
				this.EvItemClick.fire(this, {Item: listitem, Event: e});
			}
		}
	}

	_onDeleteClick(listItem: ListItem)
	{
		this._deletedClick = true;
		let e = {Item: listItem, Cancel: false};
		//this.EvDeletingClick.fire(this, e);
		//if (e.Cancel)
		///	return;
		if (this._Enabled)
			this.EvDeletedClick.fire(this, e);

		setTimeout(() => this._deletedClick = false);
	}

	getItem(value: any)
	{
		return this.getItems().find(x => x.getValue() == value);
	}

	getItemById(id: string)
	{
		return this.getItems().find(x => x.getId() == id);
	}

	setItems(items: IItem[] | ListItem[], _clear?: boolean)
	{
		if (_clear !== false)
			this.clear();
		this._Items = [];
		if (items)
			this.addItems(items as IItem[]);
	}

	getItems()
	{
		return this._Items;
	}

	getRealItems()
	{
		return this._Items.filter(item => !(item instanceof ListGroupHeader) && !item._IsSeparator);
	}

	getSelectedItem()
	{
		return this._SelectedItem;
	}

	getValue()
	{
		let selectedItem = this.getSelectedItem();
		return selectedItem ? selectedItem.getValue() : null;
	}

	clearSelection()
	{
		if (this._MultiSelect)
			this._Items.forEach(item => item.setSelected(false));
		else if (this._SelectedItem)
		{
			this._SelectedItem.setSelected(false);
			this._SelectedItem = null;
		}
	}

	setValue(value: any, fireEvent?: boolean)
	{
		this.setSelectedItem(this.getItem(value), fireEvent);
	}

	setSelectedItem(item: ListItem, fireEvent?: boolean)
	{
		if (!item)
			this.clearSelection();
		else if (item.getSelectable())
		{
			if (this._MultiSelect)
			{
				item.setSelected(!item.getSelected());
			}
			else
			{
				this.clearSelection();
				this._SelectedItem = item;
				item.setSelected(true);
			}

			if (fireEvent !== false && this._Enabled)
				this.EvItemSelected.fire(this, {Item: item});
		}
	}

	clear()
	{
		this._SelectedItem = null;
		this._Items.forEach(item => item.destroy());
		this._Items = [];
	}

	removeItem(item: ListItem)
	{
		if (item)
		{
			NP.removeFromArray(this._Items, item);
			item.destroy();
			if (this._SelectedItem == item)
				this._SelectedItem = null;
		}
	}

	getItemByPropValue(propName: string, value: any)
	{
		return this.getItems().find(item => (<any>item)['get' + propName]() == value);
	}

	insert(value: IItem | ListItem | ListGroupHeader, beforeItem?: ListItem): ListItem
	{
		if (value)
		{
			let beforeIndex = this._Items.indexOf(beforeItem),
				 hasCR = false,
				 beforeNode = beforeIndex !== -1 && this._Items[beforeIndex].getRoot();
			if (!(value instanceof ListItem) && !(value instanceof ListGroupHeader))
			{
				if (value.Selectable !== false)
					value.Selectable = this._Selectable;
				if (this._AddToolTips)
					value.AddToolTips = true;
				if (value.IsRadioButton)
				{
					value = new ListItemRadio(value);
					this._MultiSelect = false;
					hasCR = true;
				}
				else if (value.IsCheckBox)
				{
					value = new ListItemCheckBox(value);
					this._MultiSelect = true;
					hasCR = true;
				}
				else if (value.IsHeader)
				{
					value = new ListGroupHeader(value);
				}
				else
				{
					if (!value.DelBtnSettings && this._DelBtnSettings)
						value.DelBtnSettings = this._DelBtnSettings;
					value = new ListItem(value);
				}
			}
			if (value instanceof ListItem)
			{
				if (value.getSelected() && !this._MultiSelect)
					this.setSelectedItem(value, false);
				value.EvDeletedClick.add(this._onDeleteClick, this);
			}
			(value as ListItem).EvClick.add(this._onItemClick, this);
			NP.insertToArray(this._Items, value, beforeIndex);
			(value as Control).putToNode(this._root, beforeNode);

			this.EvItemCreated.fire(this, {Item: value});

			if (hasCR)
				this.addClass('app-list--non-interactive');
		}
		return value as ListItem;
	}

	getSelectedItems()
	{
		return this._Items.filter(item => item.getSelected());
	}

	getLastItem()
	{
		return this._Items[this._Items.length - 1];
	}

	selectAll()
	{
		this._Items.filter(item => item.setSelected(true));
	}

	getMultiSelect()
	{
		return this._MultiSelect;
	}

	setValues(values: Array<any>)
	{
		if (this._MultiSelect && values)
			this.getItems().forEach(item => item.setSelected(values.indexOf(item.getValue()) > -1));
	}

	filterItems(text: string)
	{
		let hasItems = false;
		text = text ? text.toLowerCase().trim() : '';
		this.getRealItems().forEach(item =>
		{
			let cnt = escapeHTML(((item.getContent() || '') + (item.getSecondLine() || '')).toLowerCase());
			let vis = !text || cnt.indexOf(text) > -1;
			item.setIsVisible(vis);
			if (vis)
				hasItems = true;
		});
		return hasItems;
	}

}


export interface ListBoxItemArgs {
	Item: ListItem
}

export interface ListBoxDeleteItemArgs extends ListBoxItemArgs {
	Cancel: boolean;
}